<!-- 获取单个停车场空车位接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"2KNTYVWC",
                "remainCarportList":[{
                  "areaId":1,
                  "totalRemain":1,
                  "tempRemain":1,
                  "fixedRemain":1
                },{
                  "areaId":1,
                  "totalRemain":1,
                  "tempRemain":1,
                  "fixedRemain":1
                }]
            },
            responseCode: {
                "data": {},
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台设置停车场实时车位信息",
                t_url: this.commonUrls.test+"setParkRemainCarport",
                p_url: this.commonUrls.prod+"setParkRemainCarport",
                precondition: "无",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'remainCarportList', info2: '是', info3: 'JSONArray', info4: '区域车位信息列表' }
                        ]
                },
                {
                    titleName: 'remainCarportList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'areaId', info2: '否', info3: 'Long', info4: '区域id:如果区域为空，则设置整场' },
                        { info1: 'totalRemain', info2: '否', info3: 'Integer', info4: '总剩余车位数' },
                        { info1: 'tempRemain', info2: '否', info3: 'Integer', info4: '临时剩余车位数' },
                        { info1: 'fixedRemain', info2: '否', info3: 'Integer', info4: '固定剩余车位数' }
                        ]
                }
                ],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: []
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/setParkRemainCarport.vue